<div [formGroup]="formGroup" *ngIf="formGroup" [attr.data-e2e]="e2eId">
  <ng-container *ngIf="type === supportedType.Range; else simple">
    <span class="layout-col-2">
      <nibtravel-input
        type="text"
        inputName="start-date"
        [e2eId]="internalE2eId.DatePickerStartDate"
        [label]="labels && labels[0]"
        [placeholder]="startDatePlaceHolder"
        (focus)="onFocus('start', mbsc)"
        [formControlName]="controlName[0]"
        [validations]="validations && validations[0]"
        [validationlabel]="validationLabel?.['start']"
      ></nibtravel-input>
      <nibtravel-input
        type="text"
        inputName="end-date"
        [e2eId]="internalE2eId.DatePickerEndDate"
        [label]="labels && labels[1]"
        [placeholder]="departureDatePlaceHolder"
        (focus)="onFocus('end', mbsc)"
        [formControlName]="controlName[1]"
        [validations]="validations && validations[1]"
        [validationlabel]="validationLabel?.['end']"
      ></nibtravel-input>
      <input
        class="is-hidden"
        mbsc-range
        [mbsc-options]="settings"
        #mbsc="mobiscroll"
      />
    </span>
  </ng-container>
  <ng-template #simple>
    <nibtravel-input
      type="text"
      inputName="date"
      [e2eId]="internalE2eId.DatePickerSingleDate"
      [label]="labels"
      mbsc-calendar
      [mbsc-options]="settings"
      [formControlName]="controlName"
      [validations]="validations"
      [validationlabel]="validationLabel"
      [placeholder]="placeholder"
      class="layout-item"
    ></nibtravel-input>
  </ng-template>
</div>
